import React, { useEffect, useState } from 'react';
import { fetchMetaData } from '../../../src/BusinessPartner/actions/actionSelectors';
import ElearningPopup from '../../components/UI/Modal/ElearningPopup';

function ElearningStatus(props) {

    const [elearningpopup,setElearningPopup]=useState("");

    useEffect(() => {        
        async function elearningStatusHandler() {
            await fetchMetaData()
            .then((data) => {
                if(data.elearningPopup === "true"){
                    setTimeout(() => {
                    setElearningPopup(data.elearningPopup);
                },1000);
                }else{
                    setElearningPopup("false");
                    props.setShowElearningPopup();
                }    
            })
            .catch((error) => {
                setElearningPopup("false");
                props.setShowElearningPopup();
            })
        }
        if(props.showElearningPopup){
            elearningStatusHandler();
        }
    }, []);

    return (
            elearningpopup === "true" ? <ElearningPopup 
            setShowElearningPopup={props.setShowElearningPopup} 
            BusinessPartnerCode={props.BusinessPartnerCode}
            UserId ={props.UserId} /> : null

    );

}

export default ElearningStatus;